import { ProgressBar } from '@paysense-india-services/elevate-web'

import CardComponent from '@/components/CardComponent/index'

const LoanDetailCard = ({ data }) => {
  return (
    <CardComponent>
      <div className='ew-text-uppercase ps-fw-medium ew-typography-micro ew-color-secondary'>
        {data?.subtitle}
      </div>
      <span className='ew-typography-extra-large'>{data?.title}</span>{' '}
      <span className='ew-color-secondary ew-fw-medium ew-typography-tiny'>
        {data?.meta?.loanDescription}
      </span>
      <ProgressBar value={data?.meta?.percentage} />
      <div className='ew-typography-small ew-fw-regular ew-color-secondary ew-mt-8'>
        {data?.description}
      </div>
    </CardComponent>
  )
}

export default LoanDetailCard
